/* eslint-disable max-len */
import React, {useEffect, useRef, useState, useContext} from 'react';
import {graphql, Link} from 'gatsby';
import PropTypes from 'prop-types';
import SEO from './SEO';
import htmr from 'htmr';
import Helmet from 'react-helmet';
// import '../styles/style.main.min.css';
// import '../styles/product-style.main.v1.min.css';
import breadcrumb from '../../static/images/home/new/breadcrumb.svg';
import Footer from './Shared/Footer';
import Header from './Shared/Header';
import cookie from 'react-cookies';
import * as utils from './Shared/Utils';
import '../styles/cookieconsent.min.css';
import Carousel from 'react-multi-carousel';
import {
  Accordion,
  Card,
  AccordionContext,
  useAccordionToggle,
  Container,
} from 'react-bootstrap';
import AssetsService from '../Application/Shared/AssetsService';
import UtmService from './Services/UtmService';
import * as styles from './Styles/coursepage.module.scss';
import dayjs from 'dayjs';
import Countdown from 'react-countdown';
import {getImage, GatsbyImage} from 'gatsby-plugin-image';
import {getMonthlySubscriptionPrice} from '../Templates/Shared/Utils';
import {scryRenderedComponentsWithType} from 'react-dom/test-utils';
import SocialShare from './Shared/SocialShare';
import {showVideoPreviewOnCoursePage}
  from '../components/Configuration/ApplicationConfig';
import CourseVideoPreview from './Shared/CourseVideoPreview';
import {
  data as pageDataJSON,
} from '../data/coursePageData.json';

/**
 * @param {object} pageData
 * @return {object} CoursePage
 */
function CoursePage({data}) {
  const canonicalPages = utils.getCanonicalPages(
      data.brandWebsiteCoursepages.url,
  );
  const pageData = {
    ...data,
    ...pageDataJSON,
    canonicalPages,
  };
  const coursePageData = pageData.brandWebsiteCoursepages;
  const headerContent = pageData.brandWebsiteHeader;
  const footerContent = pageData.brandWebsiteFooter;
  const cataloguePageData = pageData.brandWebsiteCoursecataloguepage;
  const locale = coursePageData.locale;
  const allRelatedImageData = pageData.allS3Object;
  const localizedCataloguePageLink = utils.getLocalizedPageLink(
      locale,
      cataloguePageData.url,
  );
  const localizedFacultyPageLink = utils.getLocalizedPageLink(
      locale,
      coursePageData.reference?.[0]?.url,
  );
  const localizedCoursePageLink = utils.getLocalizedPageLink(
      locale,
      coursePageData.url,
  );
  const facultySlug = coursePageData.reference?.[0]?.facultyslug;
  const courseSignupLink = utils.getLocalizedSignupLink(
      locale,
      coursePageData.courseslug,
  );
  // const courseSignupLinkUS = utils.getLocalizedSignupLinkUS(
  //     locale,
  //     coursePageData.courseslug,
  // );
  const [loadComponent, setLoadComponent] = useState(false);
  const [showPrices, setShowPrices] = useState(false);

  const wideAssetsService = new AssetsService('WEBSITE_WIDE');
  const squareAssetsService = new AssetsService('WEBSITE_SQUARE');
  const courseSchemaData = coursePageData.schema;

  const priceRef = useRef(null);
  const currencyRef = useRef(null);

  const imageData = pageData.courseImageAsset;
  const courseImage =
    imageData &&
    imageData.localFile &&
    getImage(imageData.localFile.childImageSharp.gatsbyImageData);

  const canonicalList = coursePageData.seo.canonicalurls;
  const canonicals = [];
  if (canonicalList) {
    for (let index = 0; index < canonicalList.length; index++) {
      canonicals.push({
        href: canonicalList[index].href,
        rel: 'canonical',
      });
    }
  }
  const searchTerm = coursePageData.coursemenuname.replace(/[^\w ]/g, '');

  const [activeCourse, setActiveCourse] = useState('');
  // const countryCode = cookie.load('geotargetly_country_code') || 'us';
  // const countryCode = cookie.load('geotargetly_country_code');

  useEffect(() => {
    const monthlyPrice = getMonthlySubscriptionPrice();
    if (monthlyPrice) {
      if (priceRef?.current && currencyRef?.current) {
        priceRef.current.textContent = monthlyPrice.cur_symbol;
        currencyRef.current.textContent = monthlyPrice.price;
      }
    }
    setTimeout(() => {
      setShowPrices(true);
    }, 300);
  }, []);

  // timer date
  const nextWeek = new Date();
  nextWeek.setHours(0, 0, 0, 0);
  nextWeek.setDate(nextWeek.getDate() + 1);
  const TimerRenderer = ({formatted}) => {
    return (
      <div className={styles.timerWrapper}>
        <div className={styles.textWrapper}>
          <p>{formatted.days} d</p>
          {/* <span>Days</span> */}
        </div>
        <span>:</span>
        <div className={styles.textWrapper}>
          <p>{formatted.hours} h</p>
          {/* <span>Hours</span> */}
        </div>
        <span>:</span>
        <div className={styles.textWrapper}>
          <p>{formatted.minutes} m</p>
          {/* <span>Minutes</span> */}
        </div>
        <span>:</span>
        <div className={styles.textWrapper}>
          <p>{formatted.seconds} s</p>
          {/* <span>Seconds</span> */}
        </div>
      </div>
    );
  };

  const ButtonGroup = (button) => {
    const {
      carouselState: {currentSlide, totalItems, slidesToShow},
    } = button;
    const isEndOfList = currentSlide >= totalItems - slidesToShow;
    if (totalItems > 3) {
      return (
        <div className={styles.carousalButtongroup}>
          <p
            className={`${styles.prev} ${!currentSlide && styles.disable}`}
            onClick={() => button.previous()}
          >
            {button.prevText}
          </p>
          <p
            className={`${styles.next} ${isEndOfList && styles.disable}`}
            onClick={() => button.next()}
          >
            {button.nextText}
          </p>
        </div>
      );
    } else return null;
  };

  const handleScroll = () => {
    if (typeof window !== 'undefined' && window.scrollY > 100) {
      const images = document.getElementsByTagName('img');
      Array.from(images).forEach((img) => {
        if (img.dataset.src && img.src.indexOf(img.dataset.src) <= -1) {
          img.src = img.dataset.src;
        }
      });
      if (!loadComponent) {
        setLoadComponent(true);
      }
    }
  };
  const [activeNavigatoinLink, setNavigationLink] = useState(false);
  const moduleRef = useRef();
  const cvCapacityRef = useRef();
  const cvCourses = {
    'photography': 99,
    'finance': 99,
    'marketing': 93,
    'design': 99,
    'health-wellness': 91,
    'technology': 99,
    'beauty': 91,
    'music': 90,
    'business': 96,
    'language': 90,
    'arts-hobbies': 95,
  };

  const getPercentageOfTheWeek = () => {
    const date = dayjs();
    let dayIndex = date.day();
    let hours = date.hour();
    let minutes = date.minute();
    let seconds = date.second();

    if (!dayIndex) {
      dayIndex = 7;
      hours = 0;
      minutes = 0;
      seconds = 0;
    }
    dayIndex = dayIndex * 86400;
    hours = hours * 3600;
    minutes = minutes * 60;
    const percentageOfWeek =
      ((dayIndex + hours + minutes + seconds) / 604800) * 100;
    return percentageOfWeek;
  };

  const courseSchema = {
    '@context': 'https://schema.org',
    '@type': 'Course',
    'name': coursePageData?.modular_blocks?.[0]?.herosection?.coursetitle,
    'description':
      coursePageData?.modular_blocks?.[0]?.herosection?.coursedescription,
    'provider': {
      '@type': 'Organization',
      'name': 'Upskillist',
      'sameAs': 'https://www.upskillist.com',
    },
    'offers': [{
      '@type': 'Offer',
      'category': 'Paid',
      'priceCurrency': 'USD',
      'price': 69.99,
    }],
    'hasCourseInstance': [
      {
        '@type': 'CourseInstance',
        'courseMode': [
          'Online',
        ],
        'courseWorkload': 'PT32H',
        'offers': {
          '@type': 'Offer',
          'price': '69.99',
          'priceCurrency': 'USD',
        },
      },
    ],
  };

  let passingSchemaData;
  if (courseSchemaData) {
    passingSchemaData = courseSchemaData;
  } else {
    passingSchemaData = courseSchema;
  }

  const getCapacity = (percentageOfWeek) => {
    if (cvCourses[facultySlug]) {
      return (percentageOfWeek / 100) * cvCourses[facultySlug];
    }
  };

  const setCvCapacity = () => {
    const cvCapacityCurrent =
      cvCapacityRef.current.querySelector('.cv-capacity-current') ||
      cvCapacityRef.current.querySelectorAll('.percentage');
    const cvWidth = cvCapacityRef.current.querySelector('.cv-capacity > div');
    const cvProgressSvg = cvCapacityRef.current.querySelector('.circle');

    if (cvWidth) {
      cvCapacityCurrent.textContent = 0 + '%';
      cvWidth.style.width = 0 + '%';
    } else {
      if (cvCapacityCurrent) {
        cvCapacityCurrent.textContent = 0 + '%';
      }
    }

    const percentageOfWeek = getPercentageOfTheWeek();
    let cvCapacity = getCapacity(percentageOfWeek)?.toFixed();
    if (!cvCapacity) {
      cvCapacity = '75';
    }

    const intervalFunction = () => {
      let i = 0;
      const intervalId = setInterval(() => {
        if (cvWidth) {
          cvCapacityCurrent.textContent = i + '%';
          cvWidth.style.width = cvCapacity + '%';
        } else {
          cvCapacityCurrent?.forEach((ref) => {
            ref.textContent = i + '%';
          });
          cvProgressSvg.setAttribute('stroke-dasharray', `${i} , 100`);
        }
        if (i === parseInt(cvCapacity)) {
          clearInterval(intervalId);
          return;
        }
        i++;
      }, 20);
    };

    setTimeout(() => {
      intervalFunction();
    }, 1000);
  };

  const initTrustpilot = () => {
    if (cvCapacityRef.current && window.Trustpilot) {
      const trustpilotWidget = cvCapacityRef.current.querySelector('.trustpilot-widget');
      if (trustpilotWidget) {
        window.Trustpilot.loadFromElement(trustpilotWidget, true);
      }
    }
  };

  const setcoursePosterPricing = () => {
    const monthlyPrice = getMonthlySubscriptionPrice();
    const country = cookie.load('geotargetly_country_code');
    setTimeout(() => {
      if (monthlyPrice) {
        const dynamicPricex = document.querySelector('.posterDynamicPricing');
        const dynamicCurrency = document.querySelector(
            '.posterDynamicCurrency',
        );

        if (!!dynamicPricex && !!dynamicCurrency) {
          dynamicPricex.innerText = monthlyPrice.price;
          dynamicCurrency.innerText = monthlyPrice.cur_symbol;
        }
      }
    }, 1000);
  };

  //
  const [goingDown, setGoingDown] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 400 && !goingDown) {
        setGoingDown(true);
      }
      if (currentScrollY < 400 && goingDown) {
        setGoingDown(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {passive: true});
    return () => window.removeEventListener('scroll', handleScroll);
  }, [goingDown]);

  useEffect((props) => {
    const utmService = new UtmService();
    utmService.init();
    const trackingObj = {
      pageKind: 'WebsiteCoursePage',
      locale,
      courseSlug: coursePageData.courseslug,
      facultySlug,
    };

    setCvCapacity();
    initTrustpilot();
    setcoursePosterPricing();
    setNavigationLink((prevState) => ({
      [headerNavigationLinks[0]?.id]: true,
    }));
    utils.trackPageView(trackingObj);
    utils.setChatBotVisibility(false);
    utils.initializePrices();
    window.addEventListener('scroll', handleScroll);
    cookie.save('coursePicked', coursePageData.courseslug, {
      path: '/',
      domain: process.env.CookieDomain,
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const image = coursePageData.seo.image ? coursePageData.seo.image.href : '';
  const headerNavigationLinks = [];
  coursePageData.modular_blocks?.forEach((block) => {
    const linkObject = {};
    // if (block.sections?.title) {
    //   linkObject.id = block.sections.containerid;
    //   linkObject.title = block.sections.title;
    //   headerNavigationLinks.push(linkObject);
    // }
    if (block.herosection?.title) {
      linkObject.id = block.herosection.containerid;
      linkObject.title = block.herosection.title;
      headerNavigationLinks.push(linkObject);
    }
    if (block.coursemodulecontent) {
      linkObject.id = block.coursemodulecontent.containerid;
      linkObject.title = block.coursemodulecontent.title;
      headerNavigationLinks.push(linkObject);
    }
    if (block.newcoursemodulecontent) {
      linkObject.id = block.newcoursemodulecontent.containerid;
      linkObject.title = block.newcoursemodulecontent.title;
      headerNavigationLinks.push(linkObject);
    }
    if (block.commonsections?.title) {
      linkObject.id = block.commonsections.containerid;
      linkObject.title = block.commonsections.title;
      headerNavigationLinks.push(linkObject);
    }
  });

  const scrollToSection = (e, sectionName) => {
    e.preventDefault();
    e.stopPropagation();

    setNavigationLink((prevState) => ({
      [sectionName]: true,
    }));
    const sectionTop = document.getElementById(sectionName).offsetTop;
    let offsetValue = 270;
    if (window.innerWidth < 640) {
      offsetValue = 160;
    }
    window.scrollTo(0, sectionTop - offsetValue);
  };
  const contentPath = '/images/product-page/new/content-section';

  const [showLessonList, changeCurrentLessonList] = useState([
    true,
    false,
    false,
    false,
  ]);

  const triggerLessonList = (index) => {
    const module = moduleRef.current;
    const moduleTop = module.offsetTop;
    let offsetValue = 270;
    if (window.innerWidth < 640) {
      offsetValue = 220;
    }
    window.scrollTo(0, moduleTop - offsetValue);
    changeCurrentLessonList((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false)),
    );
  };

  useEffect(() => {
    utils.initializePrices();
    setcoursePosterPricing();
  }, [loadComponent]);

  const ContextAwareToggle = ({children, eventKey, callback}) => {
    const currentEventKey = useContext(AccordionContext);
    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = currentEventKey === eventKey;
    return (
      <Accordion.Toggle
        as={Card.Header}
        className={isCurrentEventKey ? 'moduledata active' : 'moduledata'}
        onClick={decoratedOnClick}
      >
        {children}
      </Accordion.Toggle>
    );
  };
  ContextAwareToggle.propTypes = {
    children: PropTypes.any,
    eventKey: PropTypes.string,
    callback: PropTypes.func,
  };
  const languageCanonicals = pageData.canonicalPages;
  const homePageLink = utils.getLocalizedPageLink(locale, '/');
  return (
    <>
      <div>
        <SEO
          locale={locale}
          title={coursePageData.seo.title}
          description={coursePageData.seo.description}
          image={image}
          canonicalUrls={canonicals}
          languageCanonicals={languageCanonicals}
          siteMetadata={pageData.site.siteMetadata}
          schemaMarkup={passingSchemaData}
        />
        <Helmet
          bodyAttributes={{
            'data-pageref': `${coursePageData.uid}`,
            'data-contenttype': 'coursepages',
            'data-locale': `${locale}`,
          }}
        />

        <Helmet>
          <script>window.dataLayer=window.dataLayer||[];</script>
        </Helmet>

        <Helmet>
          <script async src="/js/cookieconsent-scripts.min.js"></script>
        </Helmet>

        <Helmet>
          <script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async></script>
        </Helmet>

        <Header
          headerContent={headerContent}
          isHomepage={false}
          isCatalogueSearch={false}
          locale={locale}
        />
        <main className={styles.coursePage}>
          <div className={styles.productHeaderExtension}>
            <Container>
              <div
                className={`${styles.headerContainer}
                 ${coursePageData?.reference[0]?.facultyslug}`}
                style={{backgroundColor: '#b4e6a1'}}
              >
                {/* <p className={styles.headerRule}></p> */}
                <div className={styles.headerBottomSection}>
                  <div
                    className={`${styles.headerRoutingLinks}
                 library-brand-icon-new`}
                  >
                    <Link to={homePageLink} className={styles.route}>
                      <p>Home</p>
                    </Link>
                    <div className={styles.arrow}>
                      <span>
                        <i className="icon-new-right-arrow"></i>
                      </span>
                    </div>
                    <Link
                      to={localizedCataloguePageLink}
                      className={styles.route}
                    >
                      <p>Courses</p>
                    </Link>
                    <div className={styles.arrow}>
                      <span>
                        <i className="icon-new-right-arrow"></i>
                      </span>
                    </div>
                    <Link
                      to={localizedFacultyPageLink}
                      className={styles.route}
                    >
                      <p>{coursePageData.reference?.[0]?.title}</p>
                    </Link>
                    <div className={styles.arrow}>
                      <span>
                        <i className="icon-new-right-arrow"></i>
                      </span>
                    </div>
                    <Link
                      to={localizedCoursePageLink}
                      className={styles.highlight}
                    >
                      <p>{coursePageData.coursemenuname}</p>
                    </Link>
                  </div>
                  <div className={styles.headerNavigationLinks}>
                    {headerNavigationLinks.map((link, index) => (
                      <span
                        key={`link-${index}`}
                        data-id={link.id}
                        onClick={(e) => scrollToSection(e, link.id)}
                        className={`link ${
                          activeNavigatoinLink[link.id] ? styles.highlight : ''
                        }`}
                      >
                        <p>{link.title}</p>
                        <span
                          className={`link ${
                            activeNavigatoinLink[link.id] ?
                              styles.underline :
                              ''
                          }`}
                        ></span>
                      </span>
                    ))}
                    <span>
                      <a
                        href={`https://jobbio.upskillist.com/jobs/search/jobs?searchTerm=${searchTerm}`}
                        target="__blank"
                      >
                        Careers
                      </a>
                      {/* <a href={`https://jobbio.upskillist.com/jobs/search/jobs?searchTerm=${searchTerm}&location=${countryCode}`}
                        target="__blank">
                      Careers</a> */}
                    </span>
                  </div>
                </div>
                <div className={styles.headerTimerSection}>
                  <p className={styles.timerText}>
                    <strong>SPECIAL OFFER!</strong>
                    &nbsp;- Offer Ends in:
                  </p>
                  <Countdown
                    renderer={TimerRenderer}
                    zeroPadTime={2}
                    date={nextWeek}
                  ></Countdown>
                </div>
              </div>
            </Container>
          </div>
          <Container className={styles.ProContainer} ref={cvCapacityRef}>
            {coursePageData.modular_blocks.map((section, sectionIndex) => {
              let content = '<div></div>';
              if (section.sections) {
                content = section.sections.content;
              }
              const customAltText =
                coursePageData?.modular_blocks?.[0]?.herosection?.bannerimagealttext;
              const previewVideoUrl = coursePageData?.coursepreviewvideo?.href;
              if (section.herosection) {
                return (
                  <div
                    key={sectionIndex}
                    id={section.herosection.containerid}
                    className="product-banner-section"
                  >
                    <div className="container-product">
                      <div className="row">
                        <div className="col-md-6">
                          {showVideoPreviewOnCoursePage && previewVideoUrl ? (
                            <CourseVideoPreview
                              pageData={coursePageData}
                              courseImage={courseImage}
                              signupLink={courseSignupLink}
                              customAltText={customAltText}
                              videoUrl={previewVideoUrl}
                            />
                          ) : (
                            <div className="product-banner-img">
                              {courseImage && (
                                <GatsbyImage
                                  image={courseImage}
                                  alt={
                                    customAltText ?
                                      customAltText :
                                      coursePageData.courseslug
                                  }
                                />
                              )}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div className="banner-content">
                            <div className="content-head">
                              <h6></h6>
                              <h1>{section.herosection.coursetitle}</h1>
                            </div>
                            <div className="content-info">
                              <p>{section.herosection.coursedescription}</p>
                            </div>
                            {/* {showPrices &&
                            cookie.load('geotargetly_country_code') &&
                            cookie.load('geotargetly_country_code') == 'us' ? (
                              <div className="trial-section">
                                <div className="trial-day">
                                  <div
                                    className="subscription-price USlifetime"
                                  >
                                    <div className="previousPriceSec">
                                      <p>$&nbsp;</p>
                                      <span className="price-number">250</span>
                                    </div>
                                    <div className="newPriceSec">
                                      <p>$&nbsp;</p>
                                      <span className="price-number">89</span>
                                      <p className="subText">
                                        &nbsp;(One Time)
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <p className="limited-time-offer">
                                </p>
                                <div className="share-btnsection">
                                  <Link
                                    rel="noindex nofollow"
                                    className="banner-btn btn pink-btn"
                                    to={courseSignupLinkUS}
                                  >
                                    Enroll Now
                                  </Link>
                                  <SocialShare
                                    coursePagetopSection={true}
                                    courseUrl={coursePageData.url}
                                    courseName={coursePageData.coursemenuname}
                                    activeCourse={activeCourse}
                                    setActiveCourse={setActiveCourse}
                                  ></SocialShare>
                                </div>
                              </div>
                            ) : ( */}
                            <div className="trial-section">
                              <div className="trial-day">
                                {/* <h6 className=
                              {`offer-price
                                geotargetlygeocontent1560145173081
                                case`}>
                              <span>₹</span>600 /<span>MONTH</span></h6> */}
                                <div className={'subscription-price monthly'}>
                                  <p ref={priceRef}></p>
                                  <span ref={currencyRef}>&nbsp;</span>
                                  <p className="subText">/month</p>
                                </div>
                                <p className="offer-text">
                                  {/* {section.herosection.texts.offertext}*/}
                                    Try for free
                                </p>
                              </div>
                              <p className="limited-time-offer">
                                {/* {section.herosection.texts.offerlabel} */}
                              </p>
                              <div className="share-btnsection">
                                <Link
                                  rel="noindex nofollow"
                                  className="banner-btn btn pink-btn"
                                  to={courseSignupLink}
                                >
                                  {/* {section.herosection.cta} */}
                                    Start your free trial
                                </Link>
                                <SocialShare
                                  coursePagetopSection={true}
                                  courseUrl={coursePageData.url}
                                  courseName={coursePageData.coursemenuname}
                                  activeCourse={activeCourse}
                                  setActiveCourse={setActiveCourse}
                                ></SocialShare>
                              </div>
                            </div>
                            {/* // )} */}

                            <div className="check-info">
                              <div className="check">
                                <img
                                  src="/images/home/new/checkmark.svg"
                                  alt="checkmark"
                                  width="14px"
                                  height="11px"
                                />
                                <p>{section.herosection.texts.pointone}</p>
                              </div>
                              <div className="check">
                                <img
                                  src="/images/home/new/checkmark.svg"
                                  alt="checkmark"
                                  width="14px"
                                  height="11px"
                                />
                                <p>{section.herosection.texts.pointtwo}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }

              if (section.coursemodulecontent && loadComponent) {
                return (
                  <>
                    <div
                      className={styles.oldProductContent}
                      key={`section-${sectionIndex}`}
                    >
                      <div className={styles.leftContentSection} id="content">
                        <div className={styles.courseHeader}>
                          <div
                            className={`${styles.headerImg}
                             library-brand-icon-new`}
                          >
                            <img
                              src={`${contentPath}/icon-course-content.svg`}
                              alt="course"
                            />
                          </div>
                          <div className={styles.headerTitle}>
                            <h2>{section.coursemodulecontent.heading}</h2>
                          </div>
                        </div>
                        <div
                          className={styles.moduleContentWrapper}
                          ref={moduleRef}
                        >
                          {section.coursemodulecontent.modules.map(
                              (module, index) => (
                                <div className={styles.moduleData} key={index}>
                                  <h3>{module.modulename}</h3>
                                  {showLessonList[index] &&
                                  htmr(module.modulelessoncontent)}
                                  <span
                                    onClick={() => triggerLessonList(index)}
                                    className={styles.moduleHideLessonCta}
                                  >
                                    {showLessonList[index] ?
                                    coursePageData.hidelessontext :
                                    coursePageData.showlessontext}
                                  </span>
                                </div>
                              ),
                          )}
                        </div>
                      </div>
                      <p className={styles.hr}></p>
                      <div className={styles.rightPartnerSection}>
                        <div className={styles.adobeApMb}>
                          <img
                            src="/images/transparent.png"
                            data-src={`${contentPath}/adobe-ap.png`}
                            alt="path"
                          />
                        </div>
                        <div className={styles.certifiedSection}>
                          <div className={styles.section}>
                            <div className={styles.what}>
                              <p>{coursePageData.graduates?.toLocaleString()}</p>
                            </div>
                            <div className={styles.word}>Students</div>
                          </div>
                          <div className={styles.section}>
                            <div className={styles.levelsWhat}>
                              <div className={styles.levels}>
                                <div className={styles.level1}></div>
                                <div className={styles.level2}></div>
                                <div className={styles.level3}></div>
                              </div>
                            </div>
                            <div className={styles.word}>All Levels</div>
                          </div>
                          <div className={styles.section}>
                            <div className={styles.what}>
                              <img
                                src="/images/trasparent.svg"
                                data-src={`${contentPath}/shield.svg`}
                                alt="shield"
                              />
                            </div>
                            <div className={styles.word}>Certified</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }
              if (section.newcoursemodulecontent && loadComponent) {
                const sectionData = section.newcoursemodulecontent;
                return (
                  <>
                    <div
                      className={styles.newProductContent}
                      key={`section-${sectionIndex}`}
                    >
                      <div className={styles.leftContentSection} id="content">
                        <div className={styles.learnContent}>
                          <div className={styles.courseHeader}>
                            {/* <div className={styles.headerIcon}>
                            <img src="/images/transparent.png"
                              data-src={'/images/product-page' +
                                '/new/content-section/learn-icon.png'}
                              alt="learn-icon" />
                          </div> */}
                            <div className={styles.headerTitle}>
                              <h3>Your course</h3>
                              <h2>Overview</h2>
                            </div>
                          </div>
                          <ul>
                            {sectionData.courseoutcomes.items.map(
                                (item, index) => (
                                  <li key={index}>{item}</li>
                                ),
                            )}
                          </ul>
                        </div>
                        <div className={styles.accordianContent}>
                          <div className={styles.courseHeader}>
                            {/* <div className=
                            {`${styles.headerIcon}
                            library-brand-icon-new`}>
                            <i className={`icon-${facultySlug?.
                                toLowerCase() || 'photgraphy'}`}>
                            </i>
                          </div> */}
                            <div className={styles.headerTitle}>
                              <h3>Contents</h3>
                              <h2>Of your course.</h2>
                            </div>
                          </div>
                          <Accordion defaultActiveKey="0">
                            <div
                              className={styles.moduleContent}
                              ref={moduleRef}
                            >
                              {/*  */}
                              {sectionData.modules.map(
                                  (module, moduleIndex) => (
                                    <Card key={moduleIndex}>
                                      <ContextAwareToggle
                                        eventKey={`module-${moduleIndex}`}
                                      >
                                        <div className={styles.moduleTitle}>
                                          <p>module {moduleIndex + 1}</p>
                                        </div>
                                        <div className={styles.moduleData}>
                                          <h3>{module.modulename}</h3>
                                          <div className={styles.accessSection}>
                                            {/* {!moduleIndex &&
                                        <div className={styles.freeCta}>
                                          free</div>} */}
                                            <p className={styles.addIcon}>+</p>
                                            <p className={styles.addIconMinus}>
                                            -
                                            </p>
                                          </div>
                                        </div>
                                      </ContextAwareToggle>
                                      <Accordion.Collapse
                                        eventKey={`module-${moduleIndex}`}
                                      >
                                        <Card.Body>
                                          <ol>
                                            {module.lessons.map(
                                                (lesson, lessonIndex) => (
                                                  <li key={lessonIndex}>
                                                    <details>
                                                      <summary>
                                                        {lesson.lessonname}
                                                      </summary>
                                                      <p>
                                                        {lesson.lessondescription}
                                                      </p>
                                                    </details>
                                                  </li>
                                                ),
                                            )}
                                          </ol>
                                        </Card.Body>
                                      </Accordion.Collapse>
                                    </Card>
                                  ),
                              )}
                            </div>
                          </Accordion>
                        </div>
                      </div>
                      <div className={styles.rightPartnerSection}>
                        <div className={styles.rightPartnerDetails}>
                          {/* TODO: Add this back once Skills
                      required content is added */}
                          {/* <h5 className="skills-heading">
                        Skills required
                      </h5>
                      <ul className="skills-added">
                        <li><a>Photoshop</a></li>
                        <li><a>Illustartor</a></li>
                      </ul> */}
                          {/* <div className="adobe-ap mb">
                        <img src="/images/transparent.png"
                          data-src=
                            {`${contentPath}/adobe-ap.png`}
                          alt="" />
                      </div> */}
                          <div className={styles.recognisedCertificate}>
                            <div id={styles.certifiedAccredSectionInner}>
                              <div id={styles.certifiedSectionHeader}>
                                <h6>Recognised by:</h6>
                              </div>
                              <div className={styles.certifiedImgSection}>
                                <img
                                  src="/images/product-page/new/CPD.png"
                                  data-src="/images/product-page/new/CPD.png"
                                  alt=""
                                  width="64px"
                                  height="64px"
                                />
                              </div>
                            </div>
                            <ul>
                              <li></li>
                              {/* <li className={styles.recognisedIaoIcon}>
                              <img
                                src="/images/home/new/accredited/iao-icon.png"
                                data-src=
                                  "/images/home/new/accredited/iao-icon.png"
                                alt=""/>
                            </li>
                            <li>
                              <img
                                src="/images/home/new/accredited/cpd-icon.png"
                                data-src="
                              /images/home/new/accredited/cpd-icon.png" alt=""/>
                            </li> */}
                            </ul>
                          </div>
                          <ul className={styles.productDetails}>
                            <li>
                              <div className="library-brand-icon-new">
                                <i className="icon-new-Play-1"></i>
                              </div>
                              <div className={styles.productDetailsSection}>
                                <h6>
                                  {Math.ceil(coursePageData.lessoncount / 2)} Weeks
                                </h6>
                                <p>Duration</p>
                              </div>
                            </li>
                            <li>
                              <div className="library-brand-icon-new">
                                <i className="icon-new-Play-1"></i>
                              </div>
                              <div className={styles.productDetailsSection}>
                                <h6>{coursePageData.lessoncount} Lessons</h6>
                                <p>Plus toolkits </p>
                              </div>
                            </li>
                            <li>
                              <div className="library-brand-icon-new">
                                <i className="icon-new-Play-1"></i>
                              </div>
                              <div className={styles.productDetailsSection}>
                                <h6>{coursePageData.modulecount} Modules</h6>
                                <p>Online</p>
                              </div>
                            </li>
                            <li>
                              <div className="library-brand-icon-new">
                                <i className="icon-new-Play-1"></i>
                              </div>
                              <div className={styles.productDetailsSection}>
                                <h6>Diploma</h6>
                                <p>Certification</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }
              if (section.relatedcourselistblock && loadComponent) {
                const sectionData = section.relatedcourselistblock;
                return (
                  <div
                    className={styles.productCourses}
                    key={`section-${sectionIndex}`}
                  >
                    <div className="product-courses">
                      <div className={styles.productCourseHeader}>
                        <h3>Recommended</h3>
                        <h2>Just for you!</h2>
                      </div>
                      <div className={styles.hiddenDiv}>
                        <Carousel
                          responsive={{
                            desktop: {
                              breakpoint: {max: 3000, min: 1024},
                              slidesToSlide: 3,
                              items: 3,
                            },
                            tablet: {
                              breakpoint: {max: 1024, min: 768},
                              slidesToSlide: 2,
                              items: 2,
                            },
                            mobile: {
                              breakpoint: {max: 768, min: 0},
                              slidesToSlide: 1,
                              items: 1,
                            },
                          }}
                          arrows={false}
                          // partialVisible={true}
                          customButtonGroup={
                            <ButtonGroup prevText="Prev" nextText="Next" />
                          }
                          className={styles.productCarousal}
                        >
                          {sectionData.courselist.map((course, index) => {
                            const courseId = course.courseslug;
                            const courseLink = utils.getLocalizedPageLink(
                                locale,
                                course.url,
                            );
                            const signupLink = utils.getLocalizedSignupLink(
                                locale,
                                courseId,
                            );
                            const wideImage = wideAssetsService.fetchAssetURL(
                                courseId,
                            );
                            const squareImage = squareAssetsService.fetchAssetURL(
                                courseId,
                            );
                            // const courseSignupLinkUS = utils.getLocalizedSignupLinkUS(
                            //     locale,
                            //     courseId,
                            // );
                            const currentCourseWideImageNode = allRelatedImageData.nodes.filter(
                                (node) =>
                                  node.Key.includes(courseId) &&
                                node.Key.includes('wide'),
                            )[0];
                            const courseWideImage =
                              currentCourseWideImageNode &&
                              currentCourseWideImageNode.localFile &&
                              getImage(
                                  currentCourseWideImageNode.localFile
                                      .childImageSharp.gatsbyImageData,
                              );

                            const currentCourseSquareImageNode = allRelatedImageData.nodes.filter(
                                (node) =>
                                  node.Key.includes(courseId) &&
                                node.Key.includes('square'),
                            )[0];
                            const courseSquareImage =
                              currentCourseSquareImageNode &&
                              currentCourseSquareImageNode.localFile &&
                              getImage(
                                  currentCourseSquareImageNode.localFile
                                      .childImageSharp.gatsbyImageData,
                              );
                            return (
                              <div className={styles.cardBox} key={index}>
                                <div className={styles.popularCardImg}>
                                  <Link to={courseLink}>
                                    <GatsbyImage
                                      className={styles.desktop}
                                      image={courseWideImage}
                                      alt={courseId}
                                    />
                                    <span className={styles.courseIcon}>
                                      <GatsbyImage
                                        image={courseSquareImage}
                                        alt={courseId}
                                      />
                                    </span>
                                  </Link>
                                </div>
                                <div className={styles.popCardContent}>
                                  <div className={styles.popCourseName}>
                                    <Link to={courseLink}>
                                      {course.coursemenuname}
                                    </Link>
                                    <SocialShare
                                      key={index}
                                      courseUrl={courseLink}
                                      courseName={course.coursemenuname}
                                      activeCourse={activeCourse}
                                      setActiveCourse={setActiveCourse}
                                    />
                                  </div>
                                  <div className={styles.popRating}>
                                    <div className={styles.popEnrollCount}>
                                      {course.graduates?.toLocaleString()}
                                      &nbsp; Students
                                    </div>
                                    {/* <div className={styles.StarRating}>
                                  <span>{course.rating / 10}</span>
                                  <img src="/images/transparent.png"
                                    data-src="/images/home/new/star.svg"
                                    alt="rating"
                                    width={12}
                                    height={11}
                                  />
                                </div> */}
                                  </div>
                                  <div className={styles.productCourseData}>
                                    <p>{course.coursecarddescription}</p>
                                  </div>
                                  <div className={styles.popEnrollSection}>
                                    {/* {countryCode === 'us' ? (
                                      <Link
                                        to={courseSignupLinkUS}
                                        className={styles.popEnrollCta}
                                        rel="noindex nofollow"
                                      >
                                        Enroll Now
                                      </Link>
                                    ) : ( */}
                                    <Link
                                      to={signupLink}
                                      className={styles.popEnrollCta}
                                      rel="noindex nofollow"
                                    >
                                        Enroll now
                                    </Link>
                                    {/* )} */}
                                    <Link
                                      to={courseLink}
                                      className={styles.popMoreCta}
                                      rel="noindex nofollow"
                                    >
                                      More info
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Carousel>
                      </div>
                    </div>
                  </div>
                );
              }
              if (section.commonsections && loadComponent) {
                content = section.commonsections.reference?.[0]?.content || '';
                // if (section.commonsections.title == 'Benefits') {
                //   if (countryCode === 'us') {
                //     return (
                //       <div className="course-benefits" id="benefits">
                //         <div className="course-benefits-header">
                //           <h2>Course Benefits</h2>
                //         </div>
                //         <div className="row">
                //           <div className="feature">
                //             <div className="box">
                //               <img
                //                 src="/images/transparent.png"
                //                 data-src="/images/home/new/app-section/mortarboard.svg"
                //                 width="23"
                //                 height="18"
                //                 alt="mortarboard"
                //               />
                //             </div>
                //             <div className="wording">
                //               <div className="feature-heading">
                //                 University approved
                //               </div>
                //               <div className="feature-info">
                //                 University certified courses.
                //               </div>
                //             </div>
                //           </div>
                //           <div className="feature">
                //             <div className="box">
                //               <img
                //                 src="/images/transparent.png"
                //                 data-src="/images/home/new/app-section/resume-and-cv.svg"
                //                 width="17"
                //                 height="22"
                //                 alt="resume-and-cv"
                //               />
                //             </div>
                //             <div className="wording">
                //               <div className="feature-heading">
                //                 Update your resume
                //               </div>
                //               <div className="feature-info">
                //                 Earn a recognised certificate.
                //               </div>
                //             </div>
                //           </div>
                //           <div className="feature">
                //             <div className="box">
                //               <img
                //                 src="/images/transparent.png"
                //                 data-src="/images/home/new/app-section/test.svg"
                //                 width="19"
                //                 height="21"
                //                 alt="test"
                //               />
                //             </div>
                //             <div className="wording">
                //               <div className="feature-heading">
                //                 Test your knowledge
                //               </div>
                //               <div className="feature-info">
                //                 All modules include exams.
                //               </div>
                //             </div>
                //           </div>
                //           <div className="feature">
                //             <div className="box">
                //               <img
                //                 src="/images/transparent.png"
                //                 data-src="/images/home/new/app-section/Pause-1.svg"
                //                 width="12"
                //                 height="16"
                //                 alt="Pause-1"
                //               />
                //             </div>
                //             <div className="wording">
                //               <div className="feature-heading">
                //                 Learn at your pace
                //               </div>
                //               <div className="feature-info">
                //                 Pause courses or skip lessons.
                //               </div>
                //             </div>
                //           </div>
                //         </div>
                //       </div>
                //     );
                //   } else {
                //     content =
                //       section.commonsections.reference?.[0]?.content || '';
                //   }
                // }
                // if (section.commonsections.title == 'Price') {
                //   if (countryCode === 'us') {
                //     return (
                //       <div className="subscribe-banner-container">
                //         <div className="subscribe-banner">
                //           <div className="subscribe-banner-left-section">
                //             <h2>Actionable skills,</h2>
                //             <h3>Infinite possibilities.</h3>
                //             <p>Unique lessons curated by in-house experts!</p>
                //           </div>
                //           <div className="subscribe-banner-right-section">
                //             <section>
                //               <div className="price-save">
                //                 <h3>What you&apos;ll get:</h3>
                //               </div>
                //               <ul>
                //                 <li>
                //                   Choose from
                //                   <span>&nbsp;80+ courses</span> to learn.
                //                 </li>
                //                 <li>Get the selected course for life</li>
                //                 <li>
                //                   Courses range in length up to
                //                   <span>&nbsp;32 hours.</span>
                //                 </li>
                //                 <li>
                //                   Schedule or <span>watch when you want.</span>
                //                 </li>
                //                 <li>
                //                   Industry leading{' '}
                //                   <span>customer support.</span>
                //                 </li>
                //                 <li>
                //                   Free <span>Course Materials</span>
                //                 </li>
                //               </ul>

                //               <div className="subscribe-banner-price-section">
                //                 <div
                //                   className="subscription-price USlifetime"
                //                   style={{display: 'flex', gap: '16px'}}
                //                 >
                //                   <div className="previousPriceSec">
                //                     <p>$&nbsp;</p>
                //                     <span className="price-number">250</span>
                //                   </div>
                //                   <div className="newPriceSec">
                //                     <p>$&nbsp;</p>
                //                     <span className="price-number">89</span>
                //                     <p className="subText">&nbsp;(One Time)</p>
                //                   </div>
                //                 </div>
                //               </div>
                //               <Link
                //                 to={courseSignupLinkUS}
                //                 className="subscrice-banner-cta"
                //               >
                //                 Enroll Now
                //               </Link>
                //             </section>
                //           </div>
                //         </div>
                //       </div>
                //     );
                //   } else {
                //     content =
                //       section.commonsections.reference?.[0]?.content || '';
                //   }
                // }
              }
              return (
                <React.Fragment key={`section-${sectionIndex}`}>
                  {htmr(content)}
                </React.Fragment>
              );
            })}
          </Container>
          {/* <Container>
          <div className=
            {` ${styles.stickyButton}  pro-container
          ${goingDown ? '' : styles.hide}`}>
            <div className={styles.trailDay}>
              <Link to={courseSignupLink} className={styles.bannerPinkBtn}>
                  Start learning for FREE
              </Link>
            </div>
            <div className={styles.checkInfo}>
              <div className={styles.check}>
                <img src="/images/transparent.png"
                  data-src="/images/home/new/checkmark.svg" alt="" />
                <p>FREE for 4 weeks</p>
              </div>
              <div className={styles.check}>
                <img src="/images/transparent.png"
                  data-src="/images/home/new/checkmark.svg" alt="" />
                <p>No Commitment</p>
              </div>
            </div>
          </div>
        </Container> */}
          {/*  */}
          {/* <div className={`${styles.box}
             library-brand-icon-new`}>

          <button id="btn" onClick={handleToggle} className={styles.shareBtn}>
            <i className='icon-new-Share1'></i>
          </button>
          {showDetail ?
          <ul id="list" className={styles.list}>
            <li className={styles.listItem}>
              <a className={styles.listitemLink} href="#">
                <i className='icon-new-Facebook'></i>
              </a>
            </li>
          </ul> :
           null
          }
        </div> */}

          <div>
            <Container>
              <div className={` ${styles.stickyButton}  pro-container`}>
                <div className={styles.trailDay}>
                  {/* {countryCode == 'us' ? (
                    <Link
                      to={courseSignupLinkUS}
                      className={styles.bannerPinkBtn}
                    >
                      Enroll Now
                    </Link>
                  ) : ( */}
                  <Link
                    to={courseSignupLink}
                    className={styles.bannerPinkBtn}
                  >
                      Try for free
                  </Link>
                  {/* )} */}
                </div>
                <p className={styles.stickyInfo}>
                  Sign up now and get <strong>unlimited access</strong> to{' '}
                  <strong>ALL of our courses</strong>.
                </p>
                <div className={styles.checkInfox}>
                  <div className={styles.check}>
                    <img
                      src="/images/home/new/checkmark.svg"
                      alt="checkmark"
                      width="20px"
                      height="20px"
                    />
                    <p>Globally Recognised</p>
                  </div>
                  <div className={styles.check}>
                    <img
                      src="/images/home/new/checkmark.svg"
                      alt="checkmark"
                      width="20px"
                      height="20px"
                    />
                    <p>No Commitment</p>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div className={styles.corporateSection}>
            <Container>
              <div className={styles.learnSection}>
                <h3>Learn together with</h3>
                <h2>Upskillist for Enterprise!</h2>
                <p>
                  Find 80+ courses to upskill your team. Meet your
                  organisation’s L&D goals.
                </p>
                <div className={styles.learnDetails}>
                  <div className={styles.banner}>
                    <img
                      className={styles.hideOnMobile}
                      src="/images/home/new/learn-section/bannernew.webp"
                      data-src="/images/home/new/learn-section/bannernew.webp"
                      alt="banner-img"
                      width="635"
                      height="411"
                    />
                    <img
                      className={styles.showOnMobile}
                      src="/images/home/new/learn-section/bannernewMobile.webp"
                      data-src="/images/home/new/learn-section/bannernew.webp"
                      alt="banner-img"
                      width="327"
                      height="212"
                    />
                  </div>
                  <div className={styles.planDetails}>
                    <p>Enterprise Plan</p>
                    <ul>
                      <li>Unlimited access to all courses</li>
                      <li>Data driven insights</li>
                      <li>International certification</li>
                      <li>Competitive pricing</li>
                      <li>Customisable branding & URL</li>
                      <li>Proven value & outcomes</li>
                      <li>SCORM compliant & supports LTI integration</li>
                    </ul>
                    <a
                      href="https://www.upskillist.pro/?utm_medium=referral&utm_source=upskillist.com&utm_campaign=course_page_enterprise_section"
                      target="_blank"
                      className={styles.pinklargeCta}
                      rel="noreferrer"
                    >
                      Get in touch
                    </a>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          {/* <Container className={styles.subscribeSection}>
            <div className={styles.subscriberBannerContainer}>
              <SubscribeBanner />
            </div>
          </Container> */}
        </main>
        <Footer
          footerData={footerContent}
          siteMetadata={pageData.site.siteMetadata}
        />
      </div>
    </>
  );
  TimerRenderer.propTypes = {
    formatted: PropTypes.object,
    completed: PropTypes.bool,
  };
}
CoursePage.defaultProps = {
  data: {},
};

CoursePage.propTypes = {
  data: PropTypes.object,
  isHomepage: PropTypes.bool,
  isCatalogueSearch: PropTypes.bool,
};

export default CoursePage;

export const pageQuery = graphql`
  query CoursePageID(
    $id: String
    $courseImageS3Key: String
    $custom_allRelatedS3KeysArray: [String]
  ) {
    brandWebsiteCoursepages(id: { eq: $id }) {
      uid
      locale
      title
      url
      coursecarddescription
      courseslug
      coursepreviewvideo {
        href
        title
      }
      pageslug
      graduates
      showlessontext
      hidelessontext
      coursemenuname
      lessoncount
      modulecount
      modular_blocks {
        sections {
          title
          content
          containerid
        }
        herosection {
          bannerimagealttext
          coursedescription
          coursetitle
          title
          cta
          containerid
          texts {
            monthtext
            offerlabel
            offertext
            pointone
            pointtwo
          }
        }
        newcoursemodulecontent {
          containerid
          title
          heading
          courseoutcomes {
            heading
            items
          }
          heading
          modules {
            lessons {
              lessondescription
              lessonname
            }
            modulename
          }
        }
        relatedcourselistblock {
          heading
          courselist {
            locale
            coursemenuname
            courseslug
            coursecarddescription
            rating
            graduates
            url
          }
        }
        commonsections {
          containerid
          title
          reference {
            content
          }
        }
      }
      reference {
        facultyslug
        url
        title
      }
      seo {
        title
        description
        image {
          title
          href
        }
        canonicalurls {
          title
          href
        }
      }
      schema
    }
    site {
      siteMetadata {
        title
        siteUrl
        description
        social {
          twitter
          facebook
          instagram
          linkedIn
        }
      }
    }
    courseImageAsset: s3Object(Key: { eq: $courseImageS3Key }) {
      Key
      localFile {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
    allS3Object(filter: { Key: { in: $custom_allRelatedS3KeysArray } }) {
      nodes {
        Key
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
